import { Component, OnInit } from '@angular/core';
import { DataService } from './shared/network/data.service';
import { VersionService } from './shared/version/version.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    showUpdateBanner = false;
  
    constructor(
        private dataService: DataService,
        private versionService: VersionService
    ) {}

  ngOnInit(): void {
      this.versionService.startVersionChecking();
      
      this.versionService.onUpdateAvailable.subscribe(updateAvailable => {
          this.showUpdateBanner = updateAvailable;
      });
  }

  refreshPage(): void {
      window.location.reload();
  }

  dismissBanner(): void {
      this.showUpdateBanner = false;
      this.versionService.dismissBanner();
  }
}
